import React from 'react';

import Avatar from '@atlaskit/avatar';
import type { SizeType } from '@atlaskit/avatar';
import Tooltip from '@atlaskit/tooltip';

import { UserNameStyled, UserStyled } from './User.styled';

type Props = {
  userName: string;
  userAvatar: string;
  size?: SizeType;
  isTextVisible?: boolean;
};

export const User = ({
  userName,
  userAvatar,
  size = 'medium',
  isTextVisible = true,
}: Props): JSX.Element => {
  return (
    <UserStyled>
      <Tooltip content={userName}>
        <Avatar
          size={size}
          src={userAvatar}
          borderColor='var(--ds-soldevelo-aureola-border, var( --ds-fb-soldevelo-aureola-border))'
          name={userName}
        />
      </Tooltip>
      {isTextVisible && (
        <UserNameStyled className='executed-by-name'>{userName}</UserNameStyled>
      )}
    </UserStyled>
  );
};
